<template>
  <div class="product-content">
    <div class="product-top">
      <div class="product">
        <div class="product-cont">
          <div class="product-top-box">
            <div class="left">
              <el-carousel ref="swiper" indicator-position="outside" @change="getBanner" trigger="click"
                :setActiveItem="bannerIndex" arrow="always">
                <el-carousel-item v-for="(item, index) in details.images" :key="index">
                  <img :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="right">
              <div class="product-title">{{ details.title }}</div>
              <div class="right-lsit">
                <div v-for="(key, value, index) in details.parameter" :key="index">
                  <div class="list-item">
                    <div class="list-item-left">{{ value }} </div>
                    <div class="list-item-right">{{ key }}</div>
                  </div>
                </div>

              </div>
              <div class="right-lsit-bottom">
                <div @click="getTap('/aboutUs')">contact us</div>
                <div class="download" @click="getTap('/download')">Manual download</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="product-details">
            <div class="product-title text-center">
              Product Details
            </div>
            <div class="product-details-tabbel" v-html="details.content">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="product-title text-center">
            Other products
          </div>
          <div class="product-content-box">
            <div class="product-lsit" v-for="(item, index) in productList" :key="index" @click="getItem(item)">
              <div class="item-image-box">
                <img :src="item.image" alt="">
              </div>
              <div class="item-title">{{ item.title }}</div>
              <div class="item-content">{{ item.description }}</div>
              <div class="product-lsit-button">
                <i class="el-icon-top-right" color="#FFFFFF"></i> More
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { divisionInfo, divisionOther } from '@/request/api';
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      id: "",
      details: {},
      productImage: [],
      productList: [],
      bannerIndex: 0,
    }
  },
  beforeCreate() {

    // this.channel = this.$route.query.channel
  },
  mounted() {
    this.id = this.$route.query.productId
    console.log(this.$route.query.productId)
    this.getDetails()
    this.getList()
  },
  methods: {
    getBanner(e) {
      this.bannerIndex = e
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    getTap(url, type) {
      this.$router.push({
        path: url
      })
    },
    getDetails() {
      divisionInfo({ channel: this.$route.query.channel, id: this.id }).then(res => {
        if (res.code == 1) {
          this.details = res.data
        }
      })
    },
    getList() {
      divisionOther({ channel: this.$route.query.channel, id: this.id, size: 3 }).then(res => {
        if (res.code == 1) {
          this.productList = res.data.list
        }
      })
    },
    getItem(item) {
      this.id = item.id
      console.log(item.id)
      window.scrollTo(0, 0);
      // this.channel = this.item.channel
      this.getDetails()
      this.getList()
    },
  },
}
</script>
<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.product-top {
  margin-top: 90px;
  width: 100%;
  background-image: url('../../../static/image/product-dateils-bg.png');
  background-size: 100% 100%;

  .product-top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .left {
    // width: 412px;
    width: 45%;
    height: auto;
    position: relative;

    >>>.el-carousel,
    .el-carousel__container,
    .el-carousel__item {
      width: 100%;
      // height: 300px !important;
    }

    >>>.el-carousel__container {
      width: 100%;
      height: 400px;
    }

    >>>.el-carousel__arrow {
      background: transparent !important;
      color: #000000;
      font-size: 60px;
    }

    >>>.el-carousel__button {
      width: 55px;
      height: 5px;
      background: #FFFFFF;
      opacity: 1 !important;

    }
    >>>.el-carousel__arrow{
        width: 60px;
        height: 60px;
    }
    >>>.el-carousel__indicator--horizontal.is-active .el-carousel__button {
      width: 55px;
      height: 5px;
      background: #DB2733;
    }

    // >>>.el-carousel__arrow {
    //   height: 100%;
    //   display: none;
    // }

    >>>.el-carousel__indicators {
      justify-content: center;
    }

    >>>.el-carousel__item {
      top: auto !important;
      left: auto !important;
      display: flex;
      justify-content: center;
    }

    // display: flex;
    //
    img {
      width: 312px;
      height: 328px;
      vertical-align: middle;
    }
  }

  .right {
    .product-title {
      font-size: 32px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .right-lsit::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .right-lsit::-webkit-scrollbar-track {
      background-color: transparent;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }

    .scroller::-webkit-scrollbar-thumb {
      background-color: rgba(147, 147, 153, 0.5);
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }

    .right-lsit {
      margin-top: 66px;
      max-height: 368px;
      overflow-y: scroll;

      .list-item {
        padding: 12px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #CECECE;

        .list-item-left {
          width: 50%;
          font-size: 16px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #333333;
        }

        .list-item-right {
          width: 50%;
          font-size: 16px;

          color: #333333;
        }
      }
    }

    .right-lsit-bottom {
      margin-top: 64px;
      display: flex;
      align-items: center;

      div {
        cursor: pointer;
        width: 191px;
        height: 52px;
        text-align: center;
        line-height: 52px;
        border: 2px solid #707070;
        border-radius: 26px;
        font-size: 18px;

        font-weight: 400;
        color: #333333;
      }
    }

    .download {
      margin-left: 34px;
    }

    .right-lsit-bottom div:hover {
      background: #DB2733 !important;
      border: 2px solid #DB2733;
      color: #FFFFFF;
    }
  }
}


.product-title {
  font-size: 36px;
  font-family: Arial-Bold, Arial;
  font-weight: bold;
  color: #333333;
}


.product-details-tabbel {
  margin-top: 40px;

  img {
    width: 100%;
    height: auto;
  }

  .product-details-tabbel-box {
    display: flex;
    align-items: center;
    border: 1px solid #CCCCCC;

    .product-details-tabbel-item {
      width: 25%;
      text-align: center;

      .product-details-tabbel-item-header {
        border-right: 1px solid #CCCCCC;

        font-size: 18px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #333333;
        height: 125px;
        line-height: 125px;

      }

      .product-details-tabbel-item-header:last-child {
        border-right: none !important;
      }

      .product-details-tabbel-items {
        border-top: 1px solid #CCCCCC;
        ;
        height: 70px;
        line-height: 70px;
        font-size: 14px;

        color: #333333;
        border-right: 1px solid #CCCCCC;
      }

      .product-details-tabbel-items:last-child {
        border-bottom: none !important;
      }

      .product-details-tabbel-item-conet {
        border-top: 1px solid #CCCCCC;
        ;
        width: 100%;
        height: 279px;
        font-size: 14px;

        // line-height: 26px;
        color: #333333;
        // border-right:1px solid #CCCCCC;
      }
    }
  }
}

.product-content-box {
  margin-top: 41px;
  display: flex;
  flex-wrap: wrap;
  align-items: self-start;

  .product-lsit {
    cursor: pointer;
    margin-right: 40px;
    margin-bottom: 70px;
    width: calc(100% / 3 - 40px);

    .item-image-box {
      width: 100%;
      height: 438px;
      background: #F7F7F7;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 262px;
        height: 284px;
      }
    }

    .item-title {
      margin-top: 21px;
      font-size: 24px;
      text-align: center;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .item-content {
      width: 100%;
      height: auto;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 8px;
      font-size: 15px;
      color: #999999;
      line-height: 26px;

      img {
        width: 100%;
      }
    }

    .product-lsit-button {
      cursor: pointer;
      margin: 0 auto;
      margin-top: 23px;
      width: 202px;
      height: 43px;
      text-align: center;
      line-height: 43px;
      border-radius: 29px;
      border: 2px solid #333333;
      font-size: 18px;

      color: #333333;
    }

    .product-lsit-button:hover {
      border: 2px solid #DB2733;
      background: #DB2733;
      color: #FFFFFF;
    }
  }

  .product-lsit:last-child {
    margin-right: 0px !important;
  }
}

@media screen and (max-width:767px) {
  .product-top-box {
    display: block !important;

    .left {
      width: 100% !important;

    }

    .right {
      margin-top: 30px;

      .right-lsit {
        margin-top: 30px !important;
      }
    }

  }

  .product-content-box {
    display: block !important;

    .product-lsit {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/productDetails.vue